module.exports = __webpack_public_path__ + "img/ico-sorular.243b4d3d.svg";